import { produce as applyImmutably } from 'immer';
import { handleActions } from 'redux-actions';
import { userModalActions } from 'components/usersModal';
import { presenceActions } from '../actions/presenceActions';
// Destructure the Presence actions.
export const { presenceGetAll, presenceGetAllSucceeded, presenceGetAllFailed, presenceSetStatus, presenceSetStatusSucceeded, presenceSetStatusFailed, presenceSetMediaChannel, presenceSetMediaChannelSucceeded, presenceSetMediaChannelFailed, presenceSetMedia, presenceSetMediaSucceeded, presenceSetMediaFailed, presenceSetSimultaneousRinging, presenceSetSimultaneousRingingSucceeded, presenceSetSimultaneousRingingFailed, presenceGet, presenceGetSucceeded, presenceGetFailed, presenceWsAgentStatusChanged, presenceWsSetOwnStatus, presenceWsAgentAdded, presenceShowOffline, presenceSetOthersSimultaneousRinging, presenceSetOthersSimultaneousRingingSucceeded, presenceSetOthersSimultaneousRingingFailed, presenceGetWorkloadSettings, presenceGetWorkloadSettingsSucceeded, presenceGetWorkloadSettingsFailed, presenceSetWorkloadSettings, presenceSetWorkloadSettingsSucceeded, presenceSetWorkloadSettingsFailed, } = presenceActions;
function defaultWorkloadLimits() {
    return {
        chat: 1,
        email: 1,
        messaging: 1,
        voicemail: 1,
    };
}
function defaultAllowedOffersWhileOnCall() {
    return {
        chat: true,
        email: true,
        messaging: true,
        voicemail: true,
    };
}
function initPresence() {
    return {
        last_seen: null,
        status: 'offline',
        connection_status: 'offline',
        presence_status: {
            presence_status_category: 'unknown',
            load_descriptions: [],
            simultaneous_ringing: false,
        },
        working_channels: [
            {
                channel: 'pstn_phone',
                working: false,
            },
            {
                channel: 'widget_chat',
                working: false,
            },
            {
                channel: 'messenger',
                working: false,
            },
            {
                channel: 'voicemail',
                working: false,
            },
            {
                channel: 'email',
                working: false,
            },
            {
                channel: 'contact_form',
                working: false,
            },
            {
                channel: 'callback',
                working: false,
            },
            {
                channel: 'facebook_messenger',
                working: false,
            },
            {
                channel: 'whats_app',
                working: false,
            },
            {
                channel: 'telegram',
                working: false,
            },
        ],
    };
}
// Init state for the Presence.
export const initialState = {
    meta: {
        asyncStatus: 'succeeded',
        voiceAsyncStatus: 'succeeded',
        emailAsyncStatus: 'succeeded',
        chatAsyncStatus: 'succeeded',
        messagingAsyncStatus: 'succeeded',
        simultaneousAsyncStatus: 'succeeded',
        toggleSimultaneousRing: 'succeeded',
        workloadSettingsStatus: 'succeeded',
        errors: null,
        offline: false,
    },
    presence: initPresence(),
    allPresence: [],
    workloadSettings: {
        loadLimits: defaultWorkloadLimits(),
        allowedOffersWhileOnCall: defaultAllowedOffersWhileOnCall(),
    },
};
// Reducer
const presence = handleActions({
    [presenceSetOthersSimultaneousRinging.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { toggleSimultaneousRing: 'loading' }) });
    },
    [presenceSetOthersSimultaneousRingingSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { toggleSimultaneousRing: 'succeeded' }) });
    },
    [presenceSetOthersSimultaneousRingingFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { toggleSimultaneousRing: 'failed' }) });
    },
    // USER UPDATE.
    [userModalActions.user.update.fulfilled.type]: (state, action) => {
        return applyImmutably(state, (draft) => {
            const user = Object.assign({}, action
                .payload.data);
            const draftUserPresence = draft.allPresence.find((userPresence) => userPresence.user.id === user.id);
            if (draftUserPresence) {
                draftUserPresence.user = user;
            }
        });
    },
    // PRESENCE.
    [presenceGet.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [presenceGetSucceeded.toString()]: (state, action) => {
        const agentPresence = action.payload.data;
        if (agentPresence) {
            const presence = agentPresence.presence;
            const allPresence = state.allPresence.slice();
            const presenceIndex = allPresence.findIndex((userPresence) => userPresence.user.id === agentPresence.user.id);
            if (presenceIndex === -1) {
                allPresence.push(agentPresence);
            }
            else {
                allPresence[presenceIndex] = agentPresence;
            }
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded', offline: false }), presence: 
                // Do not update if isOwnAgent flag is provided and false to maintain compatibility.
                action.payload.user_id.isOwnAgent === false
                    ? state.presence
                    : presence, allPresence });
        }
        return state;
    },
    // PRESENCE.
    [presenceGetAll.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [presenceGetAllSucceeded.toString()]: (state, action) => {
        // We find ourself in the presence returned.
        const user_id = action.payload.user_id;
        const agentPresence = action.payload.data.find((userPresence) => userPresence.user.id === user_id);
        if (agentPresence) {
            const presence = agentPresence.presence;
            const allPresence = action.payload.data;
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded', offline: false }), allPresence: allPresence, presence: presence });
        }
        return state;
    },
    [presenceWsAgentAdded.toString()]: (state, action) => {
        const presence = initPresence();
        const userPresence = {
            user: action.payload.params.agent,
            presence: presence,
        };
        return Object.assign(Object.assign({}, state), { allPresence: [...state.allPresence, userPresence] });
    },
    [presenceGetAllFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }), allPresence: [], presence: initPresence() });
    },
    [presenceSetStatus.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [presenceSetStatusSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded', offline: false }), presence: Object.assign(Object.assign({}, state.presence), { status: action.payload.data.presence_status_category }) });
    },
    [presenceSetStatusFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [presenceSetMediaChannel.toString()]: (state, action) => {
        let voiceAsyncStatus = state.meta.voiceAsyncStatus;
        let emailAsyncStatus = state.meta.emailAsyncStatus;
        let chatAsyncStatus = state.meta.chatAsyncStatus;
        let messagingAsyncStatus = state.meta.messagingAsyncStatus;
        if (action.payload.channel === 'email') {
            emailAsyncStatus = 'loading';
        }
        else if (action.payload.channel === 'widget_chat') {
            chatAsyncStatus = 'loading';
        }
        else if (action.payload.channel === 'pstnphone') {
            voiceAsyncStatus = 'loading';
        }
        else if (action.payload.channel === 'facebookmessenger') {
            messagingAsyncStatus = 'loading';
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { voiceAsyncStatus: voiceAsyncStatus, emailAsyncStatus: emailAsyncStatus, chatAsyncStatus: chatAsyncStatus, messagingAsyncStatus: messagingAsyncStatus }) });
    },
    [presenceSetMediaChannelSucceeded.toString()]: (state, action) => {
        const workingChannels = state.presence.working_channels.slice();
        let voiceAsyncStatus = state.meta.voiceAsyncStatus;
        let emailAsyncStatus = state.meta.emailAsyncStatus;
        let chatAsyncStatus = state.meta.chatAsyncStatus;
        let messagingAsyncStatus = state.meta.messagingAsyncStatus;
        const workingMediasIndex = workingChannels.findIndex((workingChannel) => workingChannel.conversation_channel ===
            action.payload.data.conversation_channel);
        if (workingMediasIndex > -1) {
            workingChannels[workingMediasIndex] = Object.assign(Object.assign({}, workingChannels[workingMediasIndex]), { working: action.payload.data.working });
        }
        if (action.payload.data.channel === 'email') {
            emailAsyncStatus = 'succeeded';
        }
        else if (action.payload.data.channel === 'widget_chat') {
            chatAsyncStatus = 'succeeded';
        }
        else if (action.payload.data.channel === 'pstn_phone') {
            voiceAsyncStatus = 'succeeded';
        }
        else if (action.payload.data.channel === 'facebookmessenger') {
            messagingAsyncStatus = 'succeeded';
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { voiceAsyncStatus: voiceAsyncStatus, emailAsyncStatus: emailAsyncStatus, chatAsyncStatus: chatAsyncStatus, messagingAsyncStatus: messagingAsyncStatus }), presence: Object.assign(Object.assign({}, state.presence), { working_channels: workingChannels }) });
    },
    [presenceSetMediaChannelFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { voiceAsyncStatus: 'failed', emailAsyncStatus: 'failed', chatAsyncStatus: 'failed', messagingAsyncStatus: 'failed' }) });
    },
    [presenceSetMedia.toString()]: (state, action) => {
        let voiceAsyncStatus = state.meta.voiceAsyncStatus;
        let emailAsyncStatus = state.meta.emailAsyncStatus;
        let chatAsyncStatus = state.meta.chatAsyncStatus;
        let messagingAsyncStatus = state.meta.messagingAsyncStatus;
        if (action.payload.media === 'email') {
            emailAsyncStatus = 'loading';
        }
        else if (action.payload.media === 'interactivechat') {
            chatAsyncStatus = 'loading';
        }
        else if (action.payload.media === 'speak') {
            voiceAsyncStatus = 'loading';
        }
        else if (action.payload.media === 'messaging') {
            messagingAsyncStatus = 'loading';
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { voiceAsyncStatus: voiceAsyncStatus, emailAsyncStatus: emailAsyncStatus, chatAsyncStatus: chatAsyncStatus, messagingAsyncStatus: messagingAsyncStatus }) });
    },
    [presenceSetMediaSucceeded.toString()]: (state, action) => {
        const media = action.payload.data.media;
        const working = action.payload.data.working;
        const workingChannels = state.presence.working_channels.slice();
        let voiceAsyncStatus = state.meta.voiceAsyncStatus;
        let emailAsyncStatus = state.meta.emailAsyncStatus;
        let chatAsyncStatus = state.meta.chatAsyncStatus;
        let messagingAsyncStatus = state.meta.messagingAsyncStatus;
        let updatedWorkingChannels = [];
        if (media === 'speak') {
            voiceAsyncStatus = 'succeeded';
            updatedWorkingChannels = workingChannels.map((workingChannel) => {
                if (workingChannel.conversation_channel === 'voicemail' ||
                    workingChannel.conversation_channel === 'callback' ||
                    workingChannel.conversation_channel === 'pstnphone') {
                    return Object.assign(Object.assign({}, workingChannel), { working });
                }
                return workingChannel;
            });
        }
        else if (media === 'interactivechat') {
            chatAsyncStatus = 'succeeded';
            updatedWorkingChannels = workingChannels.map((workingChannel) => {
                if (['widgetchat', 'messenger'].includes(workingChannel.conversation_channel)) {
                    return Object.assign(Object.assign({}, workingChannel), { working });
                }
                return workingChannel;
            });
        }
        else if (media === 'email') {
            emailAsyncStatus = 'succeeded';
            updatedWorkingChannels = workingChannels.map((workingChannel) => {
                if (workingChannel.conversation_channel === 'email' ||
                    workingChannel.conversation_channel === 'contactform') {
                    return Object.assign(Object.assign({}, workingChannel), { working });
                }
                return workingChannel;
            });
        }
        else if (media === 'messaging') {
            messagingAsyncStatus = 'succeeded';
            updatedWorkingChannels = workingChannels.map((workingChannel) => {
                if (['facebookmessenger', 'whatsapp', 'telegram'].includes(workingChannel.conversation_channel)) {
                    return Object.assign(Object.assign({}, workingChannel), { working });
                }
                return workingChannel;
            });
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { voiceAsyncStatus: voiceAsyncStatus, emailAsyncStatus: emailAsyncStatus, chatAsyncStatus: chatAsyncStatus, messagingAsyncStatus: messagingAsyncStatus }), presence: Object.assign(Object.assign({}, state.presence), { working_channels: updatedWorkingChannels }) });
    },
    [presenceSetMediaFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { voiceAsyncStatus: 'failed', emailAsyncStatus: 'failed', chatAsyncStatus: 'failed', messagingAsyncStatus: 'failed' }) });
    },
    [presenceSetSimultaneousRingingSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), presence: Object.assign(Object.assign({}, state.presence), { presence_status: Object.assign(Object.assign({}, state.presence.presence_status), { simultaneous_ringing: action.payload.data.enabled }) }) });
    },
    [presenceSetSimultaneousRingingFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [presenceWsAgentStatusChanged.toString()]: (state, action) => {
        const user_id = action.payload.params.user_id;
        const allPresence = state.allPresence.slice();
        const agentPresence = allPresence.find((userPresence) => userPresence.user.id === user_id);
        if (agentPresence !== undefined) {
            const newAgentPresence = Object.assign(Object.assign({}, agentPresence), { presence: Object.assign(Object.assign({}, agentPresence.presence), { status: action.payload.params.new_status, presence_status: Object.assign(Object.assign({}, agentPresence.presence.presence_status_category), { presence_status_category: action.payload.params.presence.presence_status_category, load_descriptions: action.payload.params.presence.load_descriptions, simultaneous_ringing: action.payload.params.presence.simultaneous_ringing }), last_seen: action.payload.params.last_seen, working_channels: action.payload.params.working_channels }) });
            return Object.assign(Object.assign({}, state), { allPresence: state.allPresence.map((userPresence) => userPresence.user.id === action.payload.params.user_id
                    ? newAgentPresence
                    : userPresence) });
        }
        return state;
    },
    [presenceWsSetOwnStatus.toString()]: (state, action) => {
        const user_id = action.payload.params.user_id;
        const allPresence = state.allPresence.slice();
        const agentPresence = allPresence.find((userPresence) => userPresence.user.id === user_id);
        if (agentPresence !== undefined) {
            const newAgentPresence = Object.assign(Object.assign({}, agentPresence), { presence: Object.assign(Object.assign({}, agentPresence.presence), { status: action.payload.params.new_status, presence_status: Object.assign(Object.assign({}, agentPresence.presence.presence_status), { presence_status_category: action.payload.params.presence.presence_status_category, load_descriptions: action.payload.params.presence.load_descriptions, simultaneous_ringing: action.payload.params.presence.simultaneous_ringing }), working_channels: action.payload.params.working_channels, last_seen: action.payload.params.last_seen }) });
            return Object.assign(Object.assign({}, state), { allPresence: state.allPresence.map((userPresence) => userPresence.user.id === action.payload.params.user_id
                    ? newAgentPresence
                    : userPresence), presence: Object.assign(Object.assign({}, state.presence), { status: action.payload.params.new_status, last_seen: action.payload.params.last_seen, presence_status: Object.assign(Object.assign({}, state.presence.presence_status), { presence_status_category: action.payload.params.presence.presence_status_category, load_descriptions: action.payload.params.presence.load_descriptions, simultaneous_ringing: action.payload.params.presence.simultaneous_ringing }), working_channels: action.payload.params.working_channels }) });
        }
        return state;
    },
    [presenceShowOffline.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { allPresence: [], presence: initPresence(), meta: Object.assign(Object.assign({}, state.meta), { offline: true }) });
    },
    [presenceGetWorkloadSettings.toString().toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.workloadSettingsStatus = 'loading';
        });
    },
    [presenceGetWorkloadSettingsSucceeded.toString().toString()]: (state, action) => {
        return applyImmutably(state, (draftState) => {
            if (action.payload) {
                const { allowed_offers_while_on_call, load_limits } = action.payload.data;
                draftState.workloadSettings = {
                    loadLimits: Object.assign(Object.assign({}, defaultWorkloadLimits()), load_limits),
                    allowedOffersWhileOnCall: Object.assign(Object.assign({}, defaultAllowedOffersWhileOnCall()), allowed_offers_while_on_call),
                };
            }
            draftState.meta.workloadSettingsStatus = 'succeeded';
        });
    },
    [presenceGetWorkloadSettingsFailed.toString().toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.workloadSettingsStatus = 'failed';
        });
    },
    [presenceSetWorkloadSettings.toString().toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.workloadSettingsStatus = 'loading';
        });
    },
    [presenceSetWorkloadSettingsSucceeded.toString().toString()]: (state, action) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.workloadSettingsStatus = 'succeeded';
            draftState.workloadSettings = {
                loadLimits: Object.assign({}, action.payload.data.load_limits),
                allowedOffersWhileOnCall: Object.assign({}, action.payload.data.allowed_offers_while_on_call),
            };
        });
    },
    [presenceSetWorkloadSettingsFailed.toString().toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.workloadSettingsStatus = 'failed';
        });
    },
}, initialState);
export default presence;
